import { DynamicDecorator } from '../../DynamicDecorator/DynamicDecorator';

export const TestimonialDecorator = () => (
  <>
    <DynamicDecorator
      decorator="quadrant"
      className="text-primary-600 absolute left-0 top-6 hidden h-9 w-9 rotate-[-90deg] md:block"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-airborne absolute left-32 top-0 hidden h-6 w-6 md:block"
    />
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-butterscotch absolute bottom-24 right-0 hidden h-6 w-6 md:block"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-primary-600 absolute bottom-4 right-20 hidden h-6 w-6 md:block"
    />
  </>
);
